import { every, some, filter, get, map, find } from 'lodash';
import { v1 as uuid } from 'uuid';
import { hasMissingQuota, hasWrongQuotaSum } from 'utils/quotaHelpers';

export const defaultGenders = () => [
  {
    value: 'male',
    label: 'Male',
    refId: uuid(),
    enabled: true,
  },
  {
    value: 'female',
    label: 'Female',
    refId: uuid(),
    enabled: true,
  },
  {
    value: 'other',
    label: 'Other',
    refId: uuid(),
    enabled: false,
  },
];

export const getValidationErrors = (formValues, completes, isUnderEdit) => {
  const { values, hasQuotas } = formValues;
  const errors = {};

  if (!some(values, 'enabled')) {
    errors.valueError = true;
  }

  if (hasQuotas) {
    const anyGenderWithoutQuota = hasMissingQuota(values, isUnderEdit);
    if (anyGenderWithoutQuota) {
      errors.quotaMissing = true;
    }

    const quotaSumIsNot100 = hasWrongQuotaSum(values, completes);
    if (quotaSumIsNot100) {
      errors.quotaSumError = true;
    }
  }

  return errors;
};

export const getInitializedQuota = (values, enabled, completes) => {
  if (!enabled) return values;
  const activeValues = filter(values, 'enabled');
  let updatedValues = null;

  const quotaIsNotInitialized = every(
    activeValues,
    (value) => get(value, 'quotaCompletes', false) === false,
  );

  if (quotaIsNotInitialized) {
    const count = activeValues.length;
    const itemQuotaCompletes = Math.floor(completes / count);
    const lastItemQuotaCompletes = completes - itemQuotaCompletes * (count - 1);
    const lastItemId = activeValues[count - 1].refId;

    updatedValues = map(values, (value) => {
      const isLastItem = value.refId === lastItemId;
      const isActiveItem = find(
        activeValues,
        ({ refId }) => value.refId === refId,
      );
      const quotaCompletes = isLastItem
        ? lastItemQuotaCompletes
        : itemQuotaCompletes;

      if (isActiveItem) {
        return { ...value, quotaCompletes };
      }

      return value;
    });

    return updatedValues;
  }
  return values;
};
